import { createFileRoute } from "@tanstack/react-router";
import { VideoWatchPage } from "@/components/VideoWatchPage";
import { watchVideos, watchVideoHead } from "@/data/watchVideos";

export const Route = createFileRoute("/videos/sunbrella-fabric")({
  head: () => watchVideoHead(watchVideos.sunbrella),
  component: () => <VideoWatchPage video={watchVideos.sunbrella} />,
});